import React from "react";
import SourcingModuleContent from "../components/sourcing/sourcing-module";

const SourcingModule = () => {
  return <SourcingModuleContent />;
};

export default SourcingModule;
